import React, {
  useState,
  useCallback,
  useMemo,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { Stack } from 'react-bootstrap';
import { SalaryChangeComponentProps } from './types';
import { SalaryChangeStepOne } from './SalaryChangeStepOne';
import { SalaryChangeStepTwo } from './SalaryChangeStepTwo';

export type SalaryChangeStepsWrapperRef = {
  getCurrentSubStep: () => number;
  goBack: () => boolean;
};

export const SalaryChangeStepsWrapper = forwardRef<
  SalaryChangeStepsWrapperRef,
  SalaryChangeComponentProps
>(
  (
    {
      selectedEmployeeId,
      currentSalary = 0,
      currency = '$',
      onChange,
      value,
      positionChangeData,
    },
    ref,
  ) => {
    const [currentSubStep, setCurrentSubStep] = useState(0);
    const [selectedOption, setSelectedOption] = useState<
      'quick' | 'new' | null
    >(
      value?.isQuickUpdate === true
        ? 'quick'
        : value?.isQuickUpdate === false
        ? 'new'
        : null,
    );

    const updateAmountOnly = useMemo(() => {
      return selectedOption === 'quick';
    }, [selectedOption]);

    const handleOptionSelect = useCallback((option: 'quick' | 'new') => {
      setSelectedOption(option);
      setCurrentSubStep(1);
    }, []);

    useImperativeHandle(
      ref,
      () => ({
        getCurrentSubStep: () => currentSubStep,
        goBack: () => {
          if (currentSubStep === 1) {
            setCurrentSubStep(0);
            return true;
          }
          return false;
        },
      }),
      [currentSubStep],
    );

    const renderCurrentStep = () => {
      if (currentSubStep === 0) {
        return (
          <SalaryChangeStepOne
            selectedOption={selectedOption}
            onOptionSelect={handleOptionSelect}
          />
        );
      } else {
        return (
          <SalaryChangeStepTwo
            selectedEmployeeId={selectedEmployeeId}
            currentSalary={currentSalary}
            currency={currency}
            onChange={onChange}
            value={value}
            updateAmountOnly={updateAmountOnly}
            positionChangeData={positionChangeData}
          />
        );
      }
    };

    return (
      <div className="salary-change-steps-wrapper">
        <Stack gap={3}>{renderCurrentStep()}</Stack>
      </div>
    );
  },
);
